import React from "react"
import Block from "@bappweb/block"
import Panel from "@bappweb/panel"
import Element from "@bappweb/element"
import Page from "@smpu-web/globalmodules/page"
import "../assets/style.scss"

const Notes = () => {
  return (
    <Page padding={false} className="notes-section">
      <Panel hasFooter={false} noHeader className="notes-container">
        <Element type="h2">Açıklamalar</Element>
        <Block type="ul">
          {/*eslint-disable */}
          <Element type="li">
            Kredi tahsis ücreti, kredi tutarının %0,575'i kadar olup, %15 oranındaki BSMV dâhildir.
          </Element>
          <Element type="li">
            Rehin tesis ücreti, 75,35 TL tahsil edilmektedir.
          </Element>
          <Element type="li">
            Kredi tahsis ücreti aylık ve yıllık maliyet oranlarına dâhil edilmiştir.
          </Element>
          <Element type="li">
            Kredi kullandırım anında son taksitin hesaplanması ile ilgili kuruş farklılıkları olabilmektedir. 
          </Element>
          <Element type="li">
          Taşıt kredilerinde azami vade ve kredi koşulları 0 km araçlarda aracın nihai fatura değerine, 2. el araçlarda ise aracın kasko değerine göre değişmektedir. Satın alacağınız aracın değişmesi durumunda azami vade ve kredi tutarı değişebilir
          </Element>
          {/*eslint-enable */}
        </Block>
      </Panel>
    </Page>
  )
}

export default Notes
